import store from 'src/storeWire';
import { remove_axios_indicator, set_axios_indicator } from "./slice/system";

export const __set = (running_axios_slug) => {
    try {
        setTimeout(() => {
            store.dispatch(set_axios_indicator(running_axios_slug));
        }, 1)
    } catch (e) {
    }
};

export const __remove = (running_axios_slug) => {
    try {
        setTimeout(() => {
            store.dispatch(remove_axios_indicator(running_axios_slug));
        }, 10)
    } catch (e) {
    }
};